module.exports = __webpack_public_path__ + "img/inicioImage.d03f42e7.png";